var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8718 19.6345L14.7715 13.5342C15.9285 12.1057 16.625 10.2897 16.625 8.31253C16.625 3.72903 12.896 0 8.31249 0C3.72898 0 0 3.72903 0 8.31253C0 12.896 3.72903 16.6251 8.31253 16.6251C10.2897 16.6251 12.1057 15.9285 13.5342 14.7715L19.6346 20.8719C19.8055 21.0427 20.0824 21.0427 20.2533 20.8719L20.8719 20.2533C21.0427 20.0824 21.0427 19.8054 20.8718 19.6345ZM8.31253 14.875C4.69376 14.875 1.75002 11.9313 1.75002 8.31253C1.75002 4.69376 4.69376 1.75002 8.31253 1.75002C11.9313 1.75002 14.875 4.69376 14.875 8.31253C14.875 11.9313 11.9313 14.875 8.31253 14.875Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.510e40e05264e86fdf78f114bd15b1fe.svg";
export { ForwardRef as ReactComponent };